import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Checkbox,
  Collapse,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import ExpressionField from "./ExpressionField";
import Flow from "./ExpressionFlow";
import { expressionTreeToFlowData } from "./expressionTreeToFlowData";
import { buildExpressionTree } from "./expressionUtils";

const AssignmentTypeComp = ({ path }) => {
  const { control } = useFormContext();
  const [selectedNode, setSelectedNode] = useState(null);

  const expression = useWatch({
    control,
    name: `${path}.EXPRESSION`,
  });

  const expressionTree = useMemo(
    () => buildExpressionTree(expression),
    [expression]
  );

  const flowData = expressionTreeToFlowData(expressionTree);

  const handleNodeClick = (event, node) => {
    setSelectedNode(node?.data);
    // Now `selectedNodeId` can be used to highlight the corresponding input/data
  };
  const { isOpen, onToggle } = useDisclosure();
  return (
    <Box
      mt={4}
      p={3}
      bg="purple.50"
      borderRadius="md"
      border="1px solid"
      borderColor="purple.200"
    >
      <Box mt={2}>
        <Text fontWeight="medium" color="purple.700">
          🧩 Assignment
        </Text>

        <HStack spacing={4} mb={1} w="100%">
          {/* Assignment ID */}
          <FormControl flex="0 0 40%" minW={0}>
            <FormLabel>Assignment ID</FormLabel>
            <Controller
              control={control}
              name={`${path}.ID`}
              render={({ field }) => (
                <Input w="100%" bg="white" borderColor="gray.300" {...field} />
              )}
            />
          </FormControl>

          {/* Target Variable */}
          <FormControl flex="0 0 40%" minW={0}>
            <FormLabel>Target Variable</FormLabel>
            <Controller
              control={control}
              name={`${path}.FIELD`}
              defaultValue={expressionTree?.expression ?? ""}
              render={({ field }) => (
                <Input w="100%" bg="white" borderColor="gray.300" {...field} />
              )}
            />
          </FormControl>

          {/* TEMP checkbox */}
          <FormControl flex="0 0 20%" minW={0}>
            <FormLabel>TEMP</FormLabel>
            <Controller
              control={control}
              name={`${path}.TEMP`}
              render={({ field }) => (
                <Checkbox
                  isChecked={field.value === true}
                  onChange={(e) => field.onChange(e.target.checked)}
                  size="lg"
                >
                  Is Temp?
                </Checkbox>
              )}
            />
          </FormControl>
        </HStack>
      </Box>

      <ExpressionField
        control={control}
        path={`${path}.EXPRESSION`}
        selectedNode={selectedNode}
      />
      <Button
        size="xs"
        onClick={onToggle}
        rightIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      >
        Expand Expression Tree
      </Button>
      <Collapse in={isOpen} animateOpacity>
        <Box
          p={2}
          borderRadius="md"
          bg="white"
          boxShadow="md"
          border="1px solid gray"
          mt={2}
        >
          <Text mb={1}>{expressionTree?.expression}</Text>
          <Text fontWeight="bold" mb={1}>
            Expression Tree Breakdown:
          </Text>

          <Box>
            <Flow
              nodes={flowData.nodes}
              edges={flowData.edges}
              fitView
              handleNodeClick={handleNodeClick}
            />
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default AssignmentTypeComp;
